import { Avatar, AvatarFallback } from '@/_components';
import type { SupportPriority } from '@/_containers/support/shared/schemas/support-query-schema';

type PriorityIndicatorProps = {
  priority: SupportPriority;
  requesterName?: string;
  requesterAvatar?: string | null;
};

export function PriorityIndicator({ requesterName, requesterAvatar }: PriorityIndicatorProps) {
  return (
    <div className="relative flex items-center justify-center">
      <Avatar size="lg">
        {requesterAvatar ? (
          <img src={requesterAvatar} alt={requesterName} className="h-full w-full object-cover" />
        ) : (
          <AvatarFallback name={requesterName || '***UNKNOWN***'} />
        )}
      </Avatar>
    </div>
  );
}
